import AutomotiveIotIcon  from '@assets/images/IoT-development/Automotive-iot-icon.avif';
import fitnessWearableIcon  from '@assets/images/IoT-development/fitness-wearable-icon.avif';
import industrialIoTIcon  from '@assets/images/IoT-development/industrial-IoT-icon.avif';
import remoteHealthcareIcon  from '@assets/images/IoT-development/remote-healthcare-icon.avif';
import SmartAgricultureIcon  from '@assets/images/IoT-development/Smart-agriculture-icon.avif';
import smartEnergyMeterIcon from '@assets/images/IoT-development/smart-energy-meter-icon.avif';
import smartHomeIcon  from '@assets/images/IoT-development/smart-home-icon.avif';
import smartRetailIcon  from '@assets/images/IoT-development/smart-retail-icon.avif';


export const IndustriesWeEmpowerContent = {
    description:'We apply our IoT capabilities across a diverse range of sectors, providing tailored monitoring solutions that solve specific industry pain points:',
    List:[

    
    {
    heading:'Fitness & Wearables',text:' Developing advanced fitness trackers and wearables that sync seamlessly with health ecosystems.',
    img:fitnessWearableIcon,
    },
    {
    heading:'Automotive & Logistics',text:'Implementing vehicle tracking and fleet management systems to optimize supply chain efficiency.',
    img:AutomotiveIotIcon,
    },
    {
    heading:'Smart Homes & Cities',text:'Engineering smart home automation and urban network solutions for a more connected lifestyle.',
    img:smartHomeIcon,
    },
    {
    heading:'Remote Healthcare',text:'Creating remote healthcare monitoring tools that provide real-time patient telemetry to medical professionals.',
    img:remoteHealthcareIcon,
    },
    {
    heading:'Energy & Utilities',text:' Designing energy consumption monitoring systems that help businesses and homeowners reduce their carbon footprint.',
    img:smartEnergyMeterIcon,
    },
    {
    heading:'Smart Agriculture ',text:' Deploying industrial IoT sensors for soil health, irrigation control, and livestock management.',
    img:SmartAgricultureIcon,
    },
    {
    heading:'Industrial Manufacturing ',text:' Driving industrial automation and industrial monitoring to prevent downtime via predictive maintenance.',
    img:industrialIoTIcon,
    },
    {
    heading:'Retail & Asset Tracking',text:'Building scalable device management systems to track high-value assets across global borders.',
    img:smartRetailIcon,
    },
]
}
export const KeyFeaturesOfIOTTechnologyContent = {
    description:'The true value of an IoT application lies in its ability to seamlessly integrate physical hardware with digital intelligence. We focus on eight core pillars that define a high-performing IoT solution:',
    List:[

    
    {
    heading:'Connectivity and Communication',text:'We ensure your devices maintain a stable network presence through optimized built-in wireless connectivity, including Wi-Fi, Bluetooth, and cellular protocols like NB-IoT or LoRaWAN.'
    },
    
    {
    heading:'Sensory Input and Data Collection',text:'Our systems are designed to accurately capture sensor data from the physical world, turning environmental variables into precise digital inputs for analysis.'
    },
    
    {
    heading:'Data Processing and Intelligence',text:'We implement complex logics and integrating AI and machine learning capabilities to process information either in the cloud or directly on the device.'
    },
    
    {
    heading:'Autonomy and Self-Adaptability',text:' We build systems capable of autonomous operation, allowing remote devices to make critical decisions locally without requiring constant human intervention.'
    },
    
    {
    heading:'Interoperability',text:'Our architecture ensures that disparate IoT devices and platforms can connect multiple devices and exchange data fluidly across different ecosystems.'
    },
    
    {
    heading:'Analytics and Reporting',text:'We provide real-time data analytics support, transforming raw telemetry into actionable insights through intuitive visual dashboards and automated reports.'
    },
    {
    heading:'Automation and Control',text:'We empower users with smart automation tools, enabling the remote triggering of actions and precise hardware control from anywhere in the world.'
    },
    {
    heading:'Security and Privacy',text:"From access control to encrypted data transmission, we build a security-first architecture to protect your IP and your customer's sensitive information."
    },
  
]
}